module.exports = __webpack_public_path__ + "img/button.902bd890.png";